<template>
  <div>
    <div class="section big-55-height over-hide z-bigger">
      <div class="parallax parallax-top" style="background-image: url('img/gallery/10.jpg')"></div>
      <div class="dark-over-pages"></div>

      <div class="hero-center-section pages">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 parallax-fade-top">
              <div class="hero-text">{{settingName}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="menu-top background-black">
      <div class="container">
        <div class="row">
          <div class="col-6 px-0 px-md-3 pl-1 py-3">
            <router-link to="my-reservations">
              <span href="#" class="lang-wrap">Reservations</span>
            </router-link>

            <router-link to="my-payments">
              <span href="#" class="lang-wrap">Payments</span>
            </router-link>

            <router-link to="profile">
              <span href="#" class="lang-wrap">Profile</span>
            </router-link>
          </div>
          <div class="col-6 px-0 px-md-3 py-3 text-right"></div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "headerNav",

  methods: {},
  props: {
    settingName: String
  }
};
</script>

